export const REQUEST_KEYS = {
  REQUEST: 'get-single-request',
}
